import { render, staticRenderFns } from "./BreadcrumbTheme.vue?vue&type=template&id=2001269b&"
import script from "./BreadcrumbTheme.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports